import React from "react";

const arab = "'Cairo', 'Segoe UI', sans-serif";

export default function RoleHub({ title, sub, onClose }) {
  return (
    <div dir="rtl" style={{ position: "relative", minHeight: "calc(100vh - 140px)", fontFamily: arab, color: "var(--text)", background: "transparent", padding: "26px clamp(16px, 4vw, 52px) 44px" }}>
      <div style={{ maxWidth: 980, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
          <button onClick={onClose} style={{ display: "grid", placeItems: "center", width: 32, height: 32, padding: 0, fontFamily: "inherit", cursor: "pointer", border: "1px solid var(--line)", borderRadius: 0, background: "var(--surface)", color: "var(--text)" }}>→</button>
          <div style={{ fontSize: 19, fontWeight: "bold" }}>{title}</div>
        </div>
        <div style={{ background: "color-mix(in srgb, var(--surface) var(--card-alpha, 88%), transparent)", backdropFilter: "blur(16px)", WebkitBackdropFilter: "blur(16px)", boxShadow: "4px 4px 0 color-mix(in srgb, var(--accent) 25%, transparent)", padding: "34px 30px", minHeight: "50vh", display: "grid", placeItems: "center" }}>
          <div style={{ textAlign: "center", maxWidth: 420 }}>
            <div style={{ fontSize: 16, fontWeight: "bold", color: "var(--text)", marginBottom: 8 }}>{sub}</div>
            <div style={{ fontSize: 13, color: "var(--faint)", lineHeight: 1.9 }}>هذه الصفحة أساس جاهز - ستُبنى فيها أدوات الإدارة والتحكم الخاصة بهذا القسم في الجلسات القادمة.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
